import { TfNotice } from 'api/notices';
import { useTranslations } from 'i18n';
import mixpanel from 'mixpanel-browser';
import ReactMarkdown from 'react-markdown';
import { VisuallyHidden } from 'ui';
import styles from './updates.module.css';

interface UpdateDetailsProps {
    notice: TfNotice;
}

export function UpdateDetails({ notice }: UpdateDetailsProps) {
    const { __ } = useTranslations();

    return (
        <div className={styles['updates']}>
            <div className={styles['updates-list-item-copy']}>
                <ReactMarkdown
                    components={{
                        a: ({ href, children }) => (
                            <a
                                href={href}
                                target="_blank"
                                rel="noreferrer"
                                onClick={(event) =>
                                    mixpanel.track('NotificationLinkClicked', {
                                        link_url: href,
                                        link_text: event.currentTarget.innerText,
                                        notification_title: notice.title,
                                        notification_id: notice.id,
                                    })
                                }
                            >
                                {children}
                                <VisuallyHidden> ({__('training.open_in_new_tab')})</VisuallyHidden>
                            </a>
                        ),
                    }}
                >
                    {notice.copy}
                </ReactMarkdown>
            </div>
            <div
                className={styles['updates-list-item-image']}
                style={notice.image ? { backgroundImage: `url("${notice.image}")` } : {}}
            />
        </div>
    );
}
